import React, { useEffect, useRef, useState } from 'react';
import {
  BOOK_STYLE,
  MAKE_A_NEW_STYLE,
  NO_STYLE_SET,
  STYLE_CHANGE,
  USE_THE_BOOK_STYLE,
  YOUR_STYLES,
} from '../../utils/writerCopy';
import { styleSourceLabel } from '../../utils/styleRoom';
import './StyleChoice.css';

/**
 * Compact style line. The scene keeps the style picked here.
 * Chapter data still resolves, and This chapter shows when that is the source.
 */
export default function StyleChoice({
  name = '',
  source = '',
  styles = [],
  busy = false,
  showLine = true,
  onPick,
  onUseBook,
  onNew,
}) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      event.stopPropagation();
      setOpen(false);
    };
    const onPointer = (event) => {
      if (rootRef.current && rootRef.current.contains(event.target)) return;
      setOpen(false);
    };
    window.addEventListener('keydown', onKey, true);
    document.addEventListener('mousedown', onPointer);
    return () => {
      window.removeEventListener('keydown', onKey, true);
      document.removeEventListener('mousedown', onPointer);
    };
  }, [open]);
  const sourceLabel = styleSourceLabel(source);
  const title = (name || '').trim();
  const line = title
    ? `${title}${sourceLabel ? ` · ${sourceLabel}` : ''}`
    : NO_STYLE_SET;

  return (
    <div className="style-choice" ref={rootRef}>
      {showLine ? <p className="style-choice__line">{line}</p> : null}
      <div className="style-choice__actions">
        <button
          type="button"
          className="style-choice__btn style-choice__btn--pill"
          disabled={busy}
          aria-expanded={open}
          onClick={(event) => {
            event.stopPropagation();
            setOpen((current) => !current);
          }}
        >
          {STYLE_CHANGE}
        </button>
        {source === 'scene' && (
          <button
            type="button"
            className="style-choice__btn"
            disabled={busy}
            onClick={onUseBook}
          >
            {USE_THE_BOOK_STYLE}
          </button>
        )}
      </div>
      {open && (
        <ul className="style-choice__list">
          <li className="style-choice__heading">{YOUR_STYLES}</li>
          {styles.map((style) => (
            <li key={style.id}>
              <button
                type="button"
                className="style-choice__btn style-choice__btn--row"
                disabled={busy}
                onClick={() => {
                  setOpen(false);
                  onPick?.(style.id);
                }}
              >
                {style.name}
                {style.is_book_default ? ` · ${BOOK_STYLE}` : ''}
              </button>
            </li>
          ))}
          <li>
            <button
              type="button"
              className="style-choice__btn style-choice__btn--row"
              disabled={busy}
              onClick={() => {
                setOpen(false);
                onUseBook?.();
              }}
            >
              {USE_THE_BOOK_STYLE}
            </button>
          </li>
          <li>
            <button
              type="button"
              className="style-choice__btn style-choice__btn--row"
              disabled={busy}
              onClick={() => {
                setOpen(false);
                onNew?.();
              }}
            >
              {MAKE_A_NEW_STYLE}
            </button>
          </li>
        </ul>
      )}
    </div>
  );
}
